module.exports = __webpack_public_path__ + "img/letters-write.d08e0d19.svg";